import { useEffect, useState } from 'react'
import styled from 'styled-components'
import OrderStatus from './components/OrderStatus'
import OrderStatusMobile from './components/mobile/OrderStatusMobile'
import { Container, Main } from './styles/main'
import { TrackerRootProps } from './types'

const MOBILE_MEDIA_QUERY = '(max-width: 800px)'

const OrderStatusContainerDesktop = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 500px;
`

const OrderStatusContainerMobile = styled.div`
  width: 100%;
  height: 500px;
`

const TrackerRoot = ({ className, orderId }: TrackerRootProps) => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window === 'undefined'
      ? false
      : window.matchMedia(MOBILE_MEDIA_QUERY).matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY)
    const updateIsMobile = () => setIsMobile(mediaQuery.matches)

    updateIsMobile()
    mediaQuery.addEventListener('change', updateIsMobile)

    return () =>
      mediaQuery.removeEventListener('change', updateIsMobile)
  }, [])

  return (
    <Container className={className}>
      <Main>
        {isMobile ? (
          <OrderStatusContainerMobile>
            <OrderStatusMobile orderId={orderId} />
          </OrderStatusContainerMobile>
        ) : (
          <OrderStatusContainerDesktop>
            <OrderStatus orderId={orderId} />
          </OrderStatusContainerDesktop>
        )}
      </Main>
    </Container>
  )
}

export default TrackerRoot
